var map = {
	"./bm_MY.json": [
		16020,
		6020
	],
	"./en_HK.json": [
		91005,
		1005
	],
	"./en_MO.json": [
		99552,
		9552
	],
	"./en_MY.json": [
		69330,
		9330
	],
	"./en_SG.json": [
		95670,
		5670
	],
	"./en_TW.json": [
		88037,
		8037
	],
	"./en_VN.json": [
		57200,
		7200
	],
	"./vi_VN.json": [
		23618,
		3618
	],
	"./zh_HK.json": [
		62418,
		2418
	],
	"./zh_MO.json": [
		96751,
		6751
	],
	"./zh_MY.json": [
		36969,
		6969
	],
	"./zh_TW.json": [
		89458,
		9458
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76884;
module.exports = webpackAsyncContext;